/* tslint:disable */
/* eslint-disable */
/**
 * Easy Invoices API v1
 * The Easy Invoices API for Shopify embedded app - automatic invoice generation and export functionality
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface CreateCannedResponseDto
 */
export interface CreateCannedResponseDto {
    /**
     * Why the operator is doing this. Stored verbatim in OperatorAuditLog.reason.
     * @type {string}
     * @memberof CreateCannedResponseDto
     */
    'reason': string;
    /**
     * 
     * @type {string}
     * @memberof CreateCannedResponseDto
     */
    'title': string;
    /**
     * German text, Sie register. May use the placeholders {{shopName}}, {{ticketReference}}, {{agentName}}.
     * @type {string}
     * @memberof CreateCannedResponseDto
     */
    'bodyDe': string;
    /**
     * English text. Same placeholders as bodyDe.
     * @type {string}
     * @memberof CreateCannedResponseDto
     */
    'bodyEn': string;
    /**
     * Ticket category the snippet is suggested for. Null or omitted = any.
     * @type {string}
     * @memberof CreateCannedResponseDto
     */
    'category'?: CreateCannedResponseDtoCategoryEnum | null;
}

/**
    * @export
    * @enum {string}
    */
export enum CreateCannedResponseDtoCategoryEnum {
    Question = 'QUESTION',
    Bug = 'BUG',
    FeatureRequest = 'FEATURE_REQUEST',
    Feedback = 'FEEDBACK',
    Billing = 'BILLING',
    TaxCompliance = 'TAX_COMPLIANCE',
    DataExport = 'DATA_EXPORT',
    Onboarding = 'ONBOARDING',
    Other = 'OTHER'
}


